import { jsx as _jsx } from "react/jsx-runtime";

function SvgGoods() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.603 2.5a1.5 1.5 0 011.477-.015l2.465 1.36L7.54 8.757 4.192 6.802l.055-.033L11.603 2.5zM6.849 9.511v4.487a.5.5 0 101 0v-3.903l3.982 2.325v9.5a1.504 1.504 0 01-.244-.113l-7.331-4.19a1.5 1.5 0 01-.756-1.303V8.066c0-.16.026-.318.074-.466L6.85 9.51zM8.52 9.33L16.552 4.4l3.844 2.122c.14.077.265.175.372.29l-8.433 4.744L8.52 9.33zm4.31 3.096l8.338-4.691c.002.033.003.067.003.1v8.48a1.5 1.5 0 01-.756 1.302l-7.34 4.192c-.078.045-.16.082-.244.112v-9.495zm.734-10.816a2.5 2.5 0 00-2.463.027L3.745 5.904A2.5 2.5 0 002.5 8.066v8.248a2.5 2.5 0 001.26 2.17l7.33 4.192a2.5 2.5 0 002.481 0l7.34-4.192a2.5 2.5 0 001.26-2.17v-8.48a2.5 2.5 0 00-1.292-2.188L13.564 1.61z"
    }, void 0)
  }), void 0);
}

export default SvgGoods;